import { inject, InjectionToken, Provider } from '@angular/core';
import { USER_SIGNAL_STORE } from '../signal-store';
import { UserSignalState } from '../../types';

export const USER_TOKEN = new InjectionToken<UserSignalState>('User');

export const USER_PROVIDER: Provider = {
  provide: USER_TOKEN,
  useClass: USER_SIGNAL_STORE,
};

export function userTokenizer() {
  return inject(USER_TOKEN);
}
